<template>
	<div
		class="summary__contents"
		:class="`is-sectionTitle-${sectionTitleStyle}`"
	>
		<div class="summary__section">
			<p class="summary__sectionTitle">{{ $t("Pârametros Gerais") }}</p>

			<div class="summary__grid">
				<div class="summary__item">
					<div class="summary__itemLabel">
						{{ $t("Tipo de simulação") }}
					</div>
					<div class="summary__itemValue">
						{{ $t(getOption("type", values.type).label) }}
					</div>
				</div>

				<div class="summary__item">
					<div class="summary__itemLabel">{{ $t("Localização") }}</div>
					<div class="summary__itemValue">
						{{ $t(getOption("location", values.location).label) }}
					</div>
				</div>
			</div>
		</div>

		<div class="summary__section">
			<p class="summary__sectionTitle">{{ $t("Dados Geométricos") }}</p>

			<div class="summary__grid">
				<div class="summary__item">
					<div class="summary__itemLabel">{{ $t("Ângulo") }}</div>
					<div class="summary__itemValue">{{ values.angle }} º</div>
				</div>

				<div class="summary__item">
					<div class="summary__itemLabel">
						{{ $t("Núm e Dim. vãos") }}
					</div>
					<div class="summary__itemValue">
						--
					</div>
				</div>

				<div class="summary__item">
					<div class="summary__itemLabel">{{ $t("Esp. entre perfís") }}</div>
					<div class="summary__itemValue">
						{{ values.profileSpacing }}
					</div>
				</div>

				<div class="summary__item">
					<div class="summary__itemLabel">
						{{ $t("Largura de apoios") }}
					</div>
					<div class="summary__itemValue">
						{{ $t(getOption("supportWidth", values.supportWidth).label) }}
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters, mapState } from "vuex";

import emitLifecycleEvents from "@/mixins/emitLifecycleEvents";

export default {
	mixins: [emitLifecycleEvents],
	props: {
		values: {
			type: Object,
			required: true,
		},
		sectionTitleStyle: {
			type: String,
			default: "block",
		},
	},
	computed: {
		...mapState("simulator", ["simulationOptions"]),
		...mapGetters("simulator", ["getOption"]),
	},
	methods: {},
};
</script>

<style lang="scss"></style>
